module.exports = __webpack_public_path__ + "static/media/hero-prod-left.b5eca56a.png";